import {ReactNode} from 'react';

import {ROLES} from './Menu';

interface Props {
  children: ReactNode;

  // Do not define `_role` -- this is used internally by the component.
  _role: string;
}

/**
 * Renders a Footer in a Menu. Analogous to a Section, but is rendered at the bottom of the menu.
 * The Footer should be passed into the Menu in the footer prop, not as a descendent.
 *
 * <Footer>
 *   <FooterOption>Option 1</FooterOption>
 *   <FooterOption>Option 2</FooterOption>
 * </Footer>
 */
export default function Footer(props: Props): JSX.Element | null {
  // See Menu implementation -- the children are rendered as is, followed by a divider.
  return null;
}

Footer.defaultProps = {
  _role: ROLES.FOOTER,
};
